/**
 * Check if value is a decimal number
 * @param {object} n
 */
export const isDecimal = (n) => {
  return Number(n) === n && n % 1 !== 0;
}
